/**
 * Build a regex from a path that will allow us to match the route and extract the params
 */
export var buildRegexFromPath = function (path) {
    path = path.replace(/:(\w+)/g, function (_, key) {
        return "(?<".concat(key, ">[^/]+)");
    });
    var source = "^(".concat(path, ")$");
    return new RegExp(source, "i");
};
/**
 * Find the current location from the URL query params, return '/' if not found
 */
export var findCurrentLocation = function (queryKey) {
    var queryParams = new URLSearchParams(window.location.search);
    return queryParams.get(queryKey) || "/";
};
/**
 * Finds the root route from the routes array if it exists
 */
export var findRootRoute = function (routes) {
    var rootRoute = null;
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var route = routes_1[_i];
        if (route.props.root) {
            rootRoute = {
                params: {},
                component: route.props.component,
            };
            break;
        }
    }
    return rootRoute;
};
/**
 * Finds the default route from the routes array if it exists
 */
export var findDefaultRoute = function (routes) {
    var defaultRoot = null;
    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
        var route = routes_2[_i];
        if (route.props.default) {
            defaultRoot = {
                params: {},
                component: route.props.component,
            };
            break;
        }
    }
    return defaultRoot;
};
/**
 * Finds the matching route from the routes array if it exists
 */
export var findMatchingRoute = function (routes, path) {
    var matchingRoute = null;
    for (var _i = 0, _a = routes.filter(function (route) { return route.props.path; }); _i < _a.length; _i++) {
        var route = _a[_i];
        var regex = buildRegexFromPath(route.props.path);
        var match = path.match(regex);
        if (match) {
            var params = match.groups || {};
            matchingRoute = {
                params: params,
                component: route.props.component,
            };
            break;
        }
    }
    return matchingRoute;
};
